export enum TextTypeEnum {
  Regular = 'regular',
  Bold = 'bold',
}